var _defs, _path, _path2, _rect, _g, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 5 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .device-group-cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .device-group-cls-1, .device-group-cls-2 {\n        fill: none;\n        stroke: currentColor;\n      }\n\n      .device-group-cls-2 {\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "device-group-cls-2",
    d: "m11.23,33.66c-1.75-.52-3.03-2.15-3.03-4.07v-13c0-2.35,1.9-4.25,4.25-4.25h22.03c2.12,0,3.87,1.55,4.2,3.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "device-group-cls-2",
    d: "m14.32,37.09c-1.78-.51-3.08-2.15-3.08-4.09v-13c0-2.35,1.9-4.25,4.25-4.25h22.03c2.12,0,3.87,1.55,4.2,3.57"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "device-group-cls-2",
    x: 18.78,
    y: 14.64,
    width: 21.5,
    height: 30.53,
    rx: 4.25,
    ry: 4.25,
    transform: "translate(-.68 59.13) rotate(-89.4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "device-group-cls-2",
    x: 20.26,
    y: 19.47,
    width: 15.17,
    height: 21.41,
    rx: 2.25,
    ry: 2.25,
    transform: "translate(-2.62 57.71) rotate(-89.4)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "device-group-cls-1",
    cx: 41.86,
    cy: 23.22,
    r: 0.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "device-group-cls-1",
    cx: 41.79,
    cy: 36.99,
    r: 0.76
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "device-group-cls-1",
    cx: 41.86,
    cy: 30.04,
    r: 0.76
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceGroup);
export default __webpack_public_path__ + "static/media/device_group.7d755f9586de483543ef0fbb85d6f668.svg";
export { ForwardRef as ReactComponent };